import { render, staticRenderFns } from "./NotificationsSnackBar.vue?vue&type=template&id=1cd5ad78"
import script from "./NotificationsSnackBar.vue?vue&type=script&lang=js"
export * from "./NotificationsSnackBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports